import { Http } from "@Services";

export const postAutocompletion = async (data: {
    question: string;
}): Promise<Array<string>> => {
    let response: Array<string>;

    try {
        response = await Http.Request<Array<string>>({
            method: "POST",
            url: "/completions/choices",
            data,
        });
    } catch (error) {
        //  @ts-ignore
        throw Error(error.statusText);
    }

    return response;
};

export default postAutocompletion;
